// config.js
export const standardProps = [
    "source", "kind", "fn", "n", "nickname", "photo",
    "bday", "anniversary", "gender", "adr", "tel",
    "email", "impp", "lang", "tz", "geo",
    "title", "role", "logo", "member", "related",
    "categories", "note", "prodid", "rev", "sound",
    "uid", "clientpidmap", "url", "version", "key",
    "fburl", "caladruri", "caluri", "class", "sort-string",
    "agent", "org", "rev", "mailer",
];

export const multipleProperties = [
    'tel', 'email', 'url', 'adr', 'impp', 'key', 'category', 'photo', 'fburl', 'caladruri', 'caluri', 'sound'];